module.exports = __webpack_public_path__ + "img/set-as-default-photo.b24e6657.svg";